export enum UserOperationType {
    Purchase = 0,
    Sale = 1,
    Withdrawal = 2,
    Replenishment = 3,
    /** Бонус к пополнению по промокоду; refId — Id депозита */
    PromoBonus = 4,
}

export enum UserOperationStatus {
    Success = 0,
    Failure = 1,
    PenaltyPoint = 2,
    Refund = 3,
    Waiting = 4,
    Processing = 5,
    System = 6,
}

export interface UserOperationInfo {
    id: number;
    gameId?: number;
    userId: bigint;
    type: UserOperationType;
    status: UserOperationStatus;
    sum: number;
    currency: string;
    titleRu: string;
    titleEn: string;
    image: string;
    date: Date;
    description?: string;
    paymentId ?: string;
    commission?: number;
    refId?: number;
    /** 0 — живой продавец, 1 — поставщик */
    source?: number;
    externalMarketKey?: string;
}

export interface UserOperationInfoResult {
    count: number;
    items: UserOperationInfo[];
}